import { render, staticRenderFns } from "./SelectKnowledgePointDialog.vue?vue&type=template&id=2fe0775c&"
import script from "./SelectKnowledgePointDialog.vue?vue&type=script&lang=js&"
export * from "./SelectKnowledgePointDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports